(() => {
  const storageKey = 'inspire_selected_city';
  const validCities = new Set(['johannesburg', 'cape-town']);
  const cityLabels = {
    johannesburg: 'Johannesburg',
    'cape-town': 'Cape Town'
  };
  const cityTags = {
    johannesburg: 'location_johannesburg',
    'cape-town': 'location_cape_town'
  };

  const isLeatherNovember = (url) => /^\/collections\/leather-november\/?$/.test(url.pathname);

  const cityCollectionUrl = (destination, city) => {
    const url = new URL(destination, window.location.origin);
    if (!validCities.has(city) || url.origin !== window.location.origin || !/\/collections\/[^/]+/.test(url.pathname)) {
      return url;
    }
    const campaign = isLeatherNovember(url);
    if (campaign) city = 'johannesburg';
    const view = campaign ? 'leather-november' : city;
    if (url.searchParams.get('view') !== view) url.searchParams.delete('page');
    url.searchParams.set('view', view);
    url.searchParams.set('filter.p.tag', cityTags[city]);
    url.searchParams.delete('section_id');
    return url;
  };

  const cityPath = (city) => {
    const root = window.Shopify?.routes?.root || '/';
    const paths = {
      johannesburg: 'pages/johannesburg',
      'cape-town': 'pages/cape-town'
    };
    return `${root}${paths[city] || ''}`;
  };

  const readStoredCity = () => {
    try {
      const value = window.localStorage.getItem(storageKey);
      return validCities.has(value) ? value : '';
    } catch (_error) {
      return '';
    }
  };

  const writeStoredCity = (city) => {
    try {
      window.localStorage.setItem(storageKey, city);
    } catch (_error) {
      // Browsing modes that disable storage still retain the cart attribute.
    }
  };

  const updatePageState = (city) => {
    document.documentElement.dataset.selectedCity = city;
    document.querySelectorAll('a[href]').forEach((link) => {
      const linkCity = link.dataset.cityContext || city;
      const destination = new URL(link.href, window.location.origin);
      if (destination.origin === window.location.origin && /\/collections\/[^/]+/.test(destination.pathname)) {
        link.href = cityCollectionUrl(link.href, linkCity).toString();
      }
    });

    document.querySelectorAll('[data-city-current-label]').forEach((label) => {
      label.textContent = cityLabels[city] || label.textContent;
    });

    document.querySelectorAll('[data-city-select]').forEach((link) => {
      const active = link.dataset.citySelect === city;
      link.toggleAttribute('aria-current', active);
    });

    document.querySelectorAll('[data-city-menu-trigger]').forEach((trigger) => {
      const active = trigger.dataset.cityMenuTrigger === city;
      trigger.toggleAttribute('aria-current', active);
    });

    document.querySelectorAll('[data-product-locations]').forEach((element) => {
      const locations = (element.dataset.productLocations || '').split(',').filter(Boolean);
      const unavailableMessage = element.querySelector('[data-city-unavailable-message]');
      if (unavailableMessage) {
        unavailableMessage.hidden = !city || locations.length === 0 || locations.includes(city);
      }
    });
  };

  const syncCheckoutAvailability = () => {
    const hasInvalidCityItem = Boolean(document.querySelector('[data-city-cart-valid="false"]'));

    document.querySelectorAll('[name="checkout"]').forEach((button) => {
      button.disabled = hasInvalidCityItem;
      button.toggleAttribute('aria-disabled', hasInvalidCityItem);
    });

    document.querySelectorAll('.additional-checkout-buttons').forEach((buttons) => {
      buttons.hidden = hasInvalidCityItem;
    });
  };

  const updateCartAttribute = async (city) => {
    const cartCityState = document.querySelector('[data-cart-city]');
    if (cartCityState && cartCityState.dataset.cartCity === city) return;

    const root = window.Shopify?.routes?.root || '/';
    try {
      await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { selected_city: city } })
      });
      document.querySelectorAll('[data-cart-city]').forEach((item) => {
        item.dataset.cartCity = city;
      });
    } catch (_error) {
      // City selection still works locally if the cart endpoint is temporarily unavailable.
    }
  };

  const selectCity = async (city, destination) => {
    if (!validCities.has(city)) return;
    writeStoredCity(city);
    updatePageState(city);
    await updateCartAttribute(city);
    if (destination) window.location.assign(destination);
  };

  const initialise = () => {
    const cityHome = document.querySelector('[data-city-home]');
    const currentUrl = new URL(window.location.href);
    const collectionCity = /\/collections\/[^/]+/.test(currentUrl.pathname) ? (isLeatherNovember(currentUrl) ? 'johannesburg' : currentUrl.searchParams.get('view')) : '';
    const pageHandle = currentUrl.pathname.match(/\/pages\/(johannesburg|cape-town)\/?$/)?.[1];
    const pageCity = collectionCity || pageHandle || cityHome?.dataset.cityHome || '';
    const switcherCity = document.querySelector('[data-cart-city]')?.dataset.cartCity;
    const selectedCity = (validCities.has(pageCity) ? pageCity : '') || readStoredCity() || switcherCity || '';

    if (selectedCity) {
      writeStoredCity(selectedCity);
      updatePageState(selectedCity);
      updateCartAttribute(selectedCity);
      const filteredUrl = cityCollectionUrl(currentUrl, selectedCity);
      if (!window.Shopify?.designMode && filteredUrl.toString() !== currentUrl.toString()) {
        window.location.replace(filteredUrl.toString());
        return;
      }
    }

    syncCheckoutAvailability();
  };

  document.addEventListener('click', async (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const selector = event.target.closest('[data-city-select], [data-city-context]');
    if (!selector) return;

    const city = selector.dataset.citySelect || selector.dataset.cityContext;
    if (!validCities.has(city)) return;
    event.preventDefault();
    const destination = selector.href ? cityCollectionUrl(selector.href, city).toString() : cityPath(city);
    await selectCity(city, destination);
  });

  document.addEventListener('DOMContentLoaded', initialise);
  document.addEventListener('facet:update', (event) => {
    const city = document.documentElement.dataset.selectedCity;
    const url = event.detail?.url;
    if (!validCities.has(city) || !url || !/\/collections\/[^/]+/.test(url.pathname)) return;
    const campaign = isLeatherNovember(url);
    const filterCity = campaign ? 'johannesburg' : city;
    url.searchParams.set('view', campaign ? 'leather-november' : city);
    url.searchParams.set('filter.p.tag', cityTags[filterCity]);
  }, true);
  document.addEventListener('shopify:section:load', initialise);
  document.addEventListener('cart:change', () => window.setTimeout(syncCheckoutAvailability));
})();

